import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';

import { PatientNfzDepartmentSelect } from './fields/PatientNfzDepartmentSelect/PatientNfzDepartmentSelect';
import { NfzDepartmentFormBean, NfzDepartmentFormController } from './PatientNfzDepartmentForm.types';

type PatientNfzDepartmentFormChildrenRenderProps = {
   handleSubmit: NfzDepartmentFormController['handleSubmit'];
   formState: NfzDepartmentFormController['formState'];
};

type PatientNfzDepartmentFormProps = {
   readonly children: (renderProps: PatientNfzDepartmentFormChildrenRenderProps) => ReactElement;
};

export const PatientNfzDepartmentForm = (props: PatientNfzDepartmentFormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<NfzDepartmentFormBean>({ nfzDepartment: null });
   return (
      <>
         <form noValidate>
            <PatientNfzDepartmentSelect register={register} />
         </form>
         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </>
   );
};
